import Box from '@mui/material/Box';
import CustomBox from '../common/CustomBox';
import CustomSubheader from './CustomSubheader';
import config from '../../config/config';
import './ProviderEducation.scss';

const ProviderEducation = props => {
  const { provider } = props;
  if (!provider.education && !provider.credentials) return <></>;
  return (
    <CustomBox borderless className='ProviderEducation'>
      <CustomSubheader>
        Education & Certifications
      </CustomSubheader>
      <Box
        className='ProviderEducation__content'
        sx={{
          '& ul li, & span, & p, & strong, & b, & i': {
            color: config().colors.lightText,
            fontSize: '0.875rem',
            fontWeight: 400,
            lineHeight: 'normal'
          },
        }}
      >
        <div
          dangerouslySetInnerHTML={{ __html: provider.education }}
        />
        <div
          dangerouslySetInnerHTML={{ __html: provider.credentials }}
        />
      </Box>
    </CustomBox>
  );
};

export default ProviderEducation;
